import React from 'react';
import { Tooltip as AntdTooltip, TooltipProps as AntdTooltipProps, ConfigProvider } from 'antd';
import { useTheme } from '../../theme/ThemeContext';

// Define the props type for your custom Tooltip component
export type TooltipProps = AntdTooltipProps & { 'data-test'?: string };

// Wrapper component for Tooltip
const Tooltip: React.FC<TooltipProps> = (props) => {
    const theme = useTheme();
    return (
        <ConfigProvider theme={theme}>
            <AntdTooltip {...props} data-test={props['data-test']} data-asper-tooltip />
        </ConfigProvider>
    );
};

export default Tooltip;
